import React, { useState } from "react";

import { useForm } from "react-hook-form";
import { useAppDispatch } from "./redux/store";
import { userActions } from "./redux/user/user.slice";
import { LoginDto } from "./model/user/dto/LoginDto";
import { useNavigate } from "react-router-dom";
import { AtiraToast } from "./utils/AtiraToast";
import { Button } from "./components/Button";

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const { register, getValues } = useForm<LoginDto>({
    defaultValues: { name: "", password: "" },
  });

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    try {
      setLoading(true);
      e.preventDefault();
      await dispatch(userActions.login(getValues())).unwrap();
      navigate("/home");
    } catch (e: any) {
      AtiraToast.apiError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="login-form m-auto d-flex flex-column justify-content-center align-items-center gap-3 bg-white rounded-4 p-4 pb-5"
    >
      <h2 className="mb-3">Login</h2>

      <div className="input-wrapper">
        <label className="fw-bold">
          User Name<span className="text-danger">*</span>
        </label>
        <input required type="text" {...register("name")} />
      </div>
      <div className="input-wrapper">
        <label className="fw-bold">
          Password<span className="text-danger">*</span>
        </label>
        <input required type="password" {...register("password")} />
      </div>
      <Button
        type="submit"
        className={`btn btn-primary mt-4 py-2 px-4`}
        loading={loading}
      >
        Login
      </Button>
    </form>
  );
};

export default Login;
